import * as _ from "lodash";
import * as ColumnHeading from "common/ui/components/table/columnHeading";
export var ColumnSize;
(function (ColumnSize) {
    ColumnSize[ColumnSize["auto"] = 0] = "auto";
    ColumnSize[ColumnSize["fill"] = 1] = "fill";
    ColumnSize[ColumnSize["col1"] = 2] = "col1";
    ColumnSize[ColumnSize["col2"] = 3] = "col2";
    ColumnSize[ColumnSize["col3"] = 4] = "col3";
    ColumnSize[ColumnSize["col4"] = 5] = "col4";
    ColumnSize[ColumnSize["col5"] = 6] = "col5";
    ColumnSize[ColumnSize["col6"] = 7] = "col6";
    ColumnSize[ColumnSize["col7"] = 8] = "col7";
    ColumnSize[ColumnSize["col8"] = 9] = "col8";
    ColumnSize[ColumnSize["col9"] = 10] = "col9";
    ColumnSize[ColumnSize["col10"] = 11] = "col10";
    ColumnSize[ColumnSize["col11"] = 12] = "col11";
    ColumnSize[ColumnSize["col12"] = 13] = "col12";
})(ColumnSize || (ColumnSize = {}));
export var ColumnAlign;
(function (ColumnAlign) {
    ColumnAlign[ColumnAlign["left"] = 0] = "left";
    ColumnAlign[ColumnAlign["center"] = 1] = "center";
    ColumnAlign[ColumnAlign["right"] = 2] = "right";
})(ColumnAlign || (ColumnAlign = {}));
export class ColumnMeta {
    constructor(order, name, displayName, size, align = ColumnAlign.left) {
        this._order = 0;
        this._columnName = "";
        this._displayName = "";
        this._isSortable = true;
        this._isLocked = false;
        this._cssClassName = null;
        this._sortOrder = ["asc", "desc"];
        this._customComponent = null;
        this._customHeaderComponent = ColumnHeading.columnHeader;
        this._customHeaderComponentProps = null;
        this.notSortable = () => {
            this._isSortable = false;
            return this;
        };
        this.cssClass = (className) => {
            this._cssClassName = `${this._cssClassName} ${className}`;
            return this;
        };
        this.sortOrder = (sortOrder) => {
            this._sortOrder = sortOrder;
            return this;
        };
        this.component = (component) => {
            this._customComponent = component;
            return this;
        };
        this.header = (header) => {
            this._customHeaderComponent = header;
            return this;
        };
        this.headerProps = (props) => {
            this._customHeaderComponentProps = props;
            return this;
        };
        this.customCompareFn = (fn) => {
            this._customCompareFn = fn;
            return this;
        };
        this._order = order;
        this._columnName = name;
        this._displayName = displayName;
        this._cssClassName = `colBase ${ColumnSize[size]} ${ColumnAlign[align]}`;
    }
    toReportColumnMeta() {
        let fields = {
            "order": this._order,
            "columnName": this._columnName,
            "displayName": this._displayName,
            "sortable": this._isSortable,
            "locked": this._isLocked,
            "sortDirectionCycle": this._sortOrder,
        };
        if (this._cssClassName) {
            _.assign(fields, { "cssClassName": this._cssClassName });
        }
        if (this._customComponent) {
            _.assign(fields, { "customComponent": this._customComponent });
        }
        if (this._customHeaderComponent) {
            _.assign(fields, { "customHeaderComponent": this._customHeaderComponent });
        }
        if (this._customHeaderComponentProps) {
            _.assign(fields, { "customHeaderComponentProps": this._customHeaderComponentProps });
        }
        if (this._customHeaderComponentProps) {
            _.assign(fields, { "customHeaderComponentProps": this._customHeaderComponentProps });
        }
        if (this._customCompareFn) {
            _.assign(fields, { "customCompareFn": this._customCompareFn });
        }
        return fields;
    }
}
